/* eslint-disable no-param-reassign */
import axios from 'axios';
import { StnAPI } from './index';
import { loginSuccess, setIsUpdating } from '../../reducers/authReducer';
import { ResetIndexedDb } from '../../../utils/ResetIndexedDb';
import { setSessionCookie } from '../../../utils/cookies';
import { getApiUrl } from '@/constants';

const getTokenFromStore = (store) => {
  return store.getState().auth.currentUser.token?.token || '';
};

const setRequestTokenInterceptor = (store) => {
  StnAPI.interceptors.request.use(
    (config) => {
      const token = getTokenFromStore(store);
      if (token) {
        config.headers['token'] = token;
      }
      return config;
    },
    (err) => Promise.reject(err),
  );
};
const refreshCreds = async (store, err) => {
  // store.dispatch({type: 'UPDATING_CREDS', payload: true})
  store.dispatch(setIsUpdating(true));
  const { token, refresh } = store.getState().auth.currentUser;
  const currentUser = store.getState().auth.currentUser;
  console.log('intercepter_RESp__1', {
    auth: store.getState().auth,
    currentUser,
    token,
    refresh,
    store,
    err,
  });
  console.log(store.getState().auth);
  try {
    const res = await axios.get(`${getApiUrl()}/auth/creds`, {
      headers: { token: token?.token, refresh },
    });
    if (res.data) {
      console.log('intercepter_RESp', res);
      // await store.dispatch({
      //   type: 'UPDATE_CREDS_SUCCESS',
      //   payload: res?.data,
      // })
      setSessionCookie(res?.data);
      localStorage.setItem('token', res.data);
      await store.dispatch(loginSuccess(res?.data));
      console.error('Try IF block ib refresh creds fucntion line 41', res.data);
      console.error(err);
      console.error(err.config.headers.token, 'Error Config Headers Token line 42');
      console.log(res);
      console.error(res.data.token.token, 'res data token token line 43');
      console.log('intercepter_RESp__122222', {
        currentUser,
        token,
        refresh,
        store,
        err,
      });
      err.config.headers.token = res.data.token.token;
      return StnAPI(err.config);
    } else {
      console.error('Error in token refresh else try and else Block:');

      handleLogout();
    }
  } catch (error) {
    console.error('Error in token refresh catch Block: ', error);
    console.log('_____________________________reset_indexed_DB___________________at_Catch_interceptors');
    ResetIndexedDb('catch');
    clearCacheData();
    // localforage.dropInstance({ name: 'STN', storeName: 'stnOne' });
    window.indexedDB.deleteDatabase('STN');
    localStorage.clear();
    sessionStorage.clear();
    window.history.pushState({}, '', '/login');
    window.location.reload();
  } finally {
    // store.dispatch({type: 'UPDATING_CREDS', payload: false})
    store.dispatch(setIsUpdating(false));
  }
};

function clearAllCookies() {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
  }
}
const clearCacheData = async () => {
  try {
    const cacheNames = await window.caches.keys();
    await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
    clearAllCookies();
    sessionStorage.clear();
    localStorage.clear();
    console.log('Complete Cache Cleared');
  } catch (error) {
    console.error('Failed to clear cache:', error);
  }
};

const handleLogout = () => {
  console.log('This hit the handleLog Fucnton ');
  console.log('_____________________________reset_indexed_DB___________________at_handleLogout_interceptors');
  ResetIndexedDb('handleLogout');
  clearCacheData();
  // localforage.dropInstance({ name: 'STN', storeName: 'stnOne' });
  window.indexedDB.deleteDatabase('STN');
  localStorage.clear();
  sessionStorage.clear();
  window.history.pushState({}, '', '/login');
  window.location.reload();
};
const setResponseTokenInterceptor = (store) => {
  StnAPI.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalConfig = err.config;
      if (
        err.response?.status === 412 &&
        (err.response?.data?.detail === 'Token Expired' || err.response?.data?.detail === 'Not authenticated')
      ) {
        if (!store.getState().auth.isUpdating) {
          console.log('_____________________________', {
            store,
            err,
          });
          return refreshCreds(store, err);
        }
        return new Promise((resolve) => {
          const intervalId = setInterval(() => {
            if (!store.getState().auth.isUpdating && store.getState().auth.currentUser.token) {
              clearInterval(intervalId);
              originalConfig.headers.token = getTokenFromStore(store);
              resolve(StnAPI(originalConfig));
            }
          }, 1000);
        });
      }

      return Promise.reject(err);
    },
  );
};

const StnSetup = (store) => {
  setRequestTokenInterceptor(store);
  setResponseTokenInterceptor(store);
};
export default StnSetup;
